import { t } from 'i18next';
import { BookingTypes } from 'api';

export const bookingOptions = [
  {
    label: t('modals.bookPhotographer.anotherDate'),
    value: BookingTypes.BookingSecondaryConfirmed,
  },
  {
    label: t('modals.bookPhotographer.actions.contactPersonBooking'),
    value: BookingTypes.Booking3rdParty,
  },
  {
    label: t('modals.bookPhotographer.actions.esoftBooking'),
    value: BookingTypes.BookingEsoft,
  },
];
